import { useTranslations } from "../../../helpers/translations";
import { PlainLink } from "../shared/PlainLink";
import React from "react";

export const SupportSubMenu = () => {
  const t = useTranslations("nav.support");

  return <PlainLink href={t("href")} title={t("title")} />;
};
